import { useEffect, useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { scrollToId } from "../lib/lenis";
import { LOGO_URL } from "../data";

const links = [
  { id: "services", label: "Serviços", testid: "nav-services" },
  { id: "method", label: "Método", testid: "nav-method" },
  { id: "results", label: "Resultados", testid: "nav-results" },
  { id: "contact", label: "Contato", testid: "nav-contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    scrollToId(id);
    setMenuOpen(false);
  };

  return (
    <header className={`nav-wrap ${scrolled ? "scrolled" : ""}`} data-testid="main-navigation">
      <div className="nav-inner">
        <button className="brand" onClick={() => go("top")} data-testid="brand-home">
          <img className="brand-logo" src={LOGO_URL} alt="Vanguard Marketing Digital" />
          <span className="brand-word"><strong>VANGUARD</strong><small>MARKETING DIGITAL</small></span>
        </button>
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          {links.map((link) => (
            <button key={link.id} onClick={() => go(link.id)} data-testid={link.testid}>{link.label}</button>
          ))}
        </nav>
        <button className="btn-gold nav-cta" onClick={() => go("contact")} data-testid="nav-book-button">
          Agendar conversa <ArrowUpRight size={15} />
        </button>
        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-button" aria-label="Abrir menu">
          {menuOpen ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
};
